


import "bootswatch/dist/lumen/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import RNavbar from "./Component/RNavbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Component/Auth/Login";
import Main from "./Component/Profile/Main";
import UserProfile from"./Component/Profile/UserProfile";
import CodingProfile from "./Component/Profile/CodingProfile";
import Leaderboard from "./Component/Leaderboard/LeaderBoardPage"
import SiteHandles from "./Component/Admin/siteHandles";
import Users from "./Component/Admin/Users";
import PreCollege from "./Component/Admin/PreCollege";
import Filter from "./Component/Admin/Filter";
import DisplayCriteria from "./Component/Criteria/DisplayCriteria";
import Edit from './Component/Admin/Criteria/Edit'
import Chart from "./Component/Leaderboard/ChartPage";
import Code from "./Component/ProblemList/Code";
import List from "./Component/ProblemList/List";
import AllSubmission from "./Component/Admin/AllSubmission";
import Submission from "./Component/Submission/SubmissionPage";
import Result from "./Component/Submission/ResultTable";
import UserProblemAllSubmission from "./Component/Submission/userProblemAllSubmissions";
import MainBatch from "./Component/Leaderboard/Main";
import ContestReports from "./Component/Admin/Reports/ContestReports";
import ProblemReport from "./Component/Admin/Reports/ProblemReports"
import AddProblem from "./Component/Admin/Reports/AddProblem"
import AdminOptions from "./Component/Admin/AdminOptions/AdminOptions";
import EditFormula from "./Component/Admin/FormulaEdit/EditFormula";
import UploadVQR from "./Component/Admin/Uploads/UploadVQR";
import MentorMentee from "./Component/Admin/MentorMentee/mentorMentee";
import MentorUpload from "./Component/Admin/MentorMentee/bulkUpdateMentor";
import DeleteMentor from "./Component/Admin/MentorMentee/bulkDeleteMentors";
import MentorsList from "./Component/Admin/MentorMentee/mentorsList";
import MentorOptions from "./Component/Mentor/MentorOptions";
import MenteeList from "./Component/Mentor/MenteeList";
import Util from "./Component/Service/util";
import AttendanceSession from "./Component/Attendance/attendanceSession";
import Attendance from "./Component/Attendance/attendance";
import User from "./Component/Admin/Uploads/User";
import SincerityScoreUpload from "./Component/Admin/Uploads/SincerityScoreUpload";
import FAQ from "./Component/FAQ/FAQ";
import UserHandleHistory from "./Component/Admin/UserHandleHistory";
import Batch from "./Component/Admin/Batch/batchEdit";
import ContestLeaderboardUpload from "./Component/Admin/Uploads/ContestLeaderboard";
import ContestAggregateReports from "./Component/Admin/Reports/ContestAggregateReport";
import BatchDetails from "./Component/Admin/Batch/BatchDetails";
import ProblemSet from "./Component/Admin/ProblemSet/ProblemSet";
import Problem from "./Component/Admin/Reports/problem";
import UpdateProblem from "./Component/Admin/Reports/updateProblem";
import BatchHistory from "./Component/Admin/Batch/BatchHistory";
import Tags from "./Component/Admin/Tags/Tags";
import Courses from "./Component/Admin/Courses/Courses";

function App() {
  const util = new Util();
  const isAdmin = util.isAdmin();
  const role = util.getRole();
  return (
    <div className="App bg-light" style={{minHeight:"100vh"}}>
      <BrowserRouter>
        <RNavbar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/profile" element={<Main />} />
          <Route path="/faq/:id" element={ <FAQ/>} />
          <Route path="/coding/profile" element={<CodingProfile />} />
          <Route exact path="/profile/:id" element={<UserProfile />} />
          <Route exact path="/coding/profile/:id" element={<CodingProfile />} />
          <Route exact path="/coding/graph/:id" element={<Chart />} />
          <Route exact path="/batch/:batch" element={ <MainBatch/>} />
          <Route exact path="/user/:userId/:site_name" element={<UserHandleHistory/>}/>


          <Route path="/" element={<Leaderboard />} />
          <Route path="/batch/:batch" element={<Leaderboard option={'2'}/>} />
          <Route path="/problemset" element={<ProblemSet/>} />

          { (role != "student") ?
            <>
            <Route path="/sites/handles" element={<SiteHandles />} />
            <Route path="/all/users" element={<Users />} />
            <Route path="/pre/college" element={<PreCollege />} />
            <Route path="/filter" element={<Filter/>}/>
            </> : null
          }

          {/* ########### Admin routes ######## */}
          {(isAdmin) ?
            <>

            <Route path="/admin" element={<AdminOptions/>}/>
            <Route path="/admin/reports/contest" element={<ContestReports/>}/>
            <Route path="/admin/reports/aggregate/contest" element={<ContestAggregateReports/>}/>
            <Route path="/admin/reports/problem" element={<ProblemReport/>}></Route>
            <Route path="/admin/add/problem" element={<AddProblem/>}></Route>
            <Route path="/admin/edit/problems" element={<UpdateProblem/>}></Route> 
            <Route path="/admin/edit/problem/:problemId" element={<Problem/>}></Route> 
            <Route path="/admin/upload/vqr" element={<UploadVQR/>}></Route>
            <Route path="/admin/upload/sincerity-score" element={<SincerityScoreUpload/>}></Route>
            <Route path="/admin/upload/contest-leaderboard" element={<ContestLeaderboardUpload />}></Route>
            <Route path="admin/leaderboard/editFormula" element={<EditFormula/>}/>
            <Route path="/admin/mentees" element={<MentorMentee/>}/>
            <Route path="/admin/college" element={<PreCollege />} />
            <Route path="/admin/criteria" element={<Edit/>} />
            <Route path="/admin/mentees/upload" element={<MentorUpload />} />
            <Route path="/admin/upload/user" element={<User />} />
            <Route path="/admin/mentees/delete" element={<DeleteMentor/>} />
            <Route path="/admin/mentees/list" element={<MentorsList/>} />
            <Route path="/admin/batch-management" element={<Batch/>} />
            <Route path='/admin/edit/:batchName' element={<BatchDetails/>}/>
            <Route path='/admin/batch/history/:batchName' element={<BatchHistory/>}/>
            <Route path="/admin/tags" element={<Tags/>}/>
            <Route path="/admin/courses" element={<Courses/>}/>

            </>
            : null}
            { (role === "mentor") ?
              <>
                  <Route path="/mentor" element={<MentorOptions/>} />
                  <Route path="/mentor/list" element={<MenteeList/>} />
                  
                  
              </>
            : null}
          <Route path="/criteria" element={<DisplayCriteria/>}/>
          {/* ########### Attendance routes ######## */}
          <Route path="/attendance-session" element={<AttendanceSession/>} />
          <Route path="/attendance-session/:sessionId" element={<Attendance/>} />

          {/* ########### CONTEST routes ######## */}
          {(localStorage.getItem('contestMode') == 'true')?(
            <>
              <Route path="/code/:pid" element={<Code/>}/>
              <Route path="/problem/submissions/:pid" element={<UserProblemAllSubmission/>}/>
              <Route path="/problem/list" element={<List/>} />
              <Route path="/allSubmissions" element={<AllSubmission/>} />

              <Route path="/submission/:id" element={<Submission/>}/>
              <Route path="/result/:id" element={<Result/>}/>
            </>
          ):null
          }
        </Routes>
      </BrowserRouter>
      <br />
      <br />
      <br />
    </div>
  );
}

export default App;